import { cx } from "class-variance-authority";
import { useTranslation } from "react-i18next";
import IcLikeFilled from "~/images/ic_like_filled.svg";
import IcLike from "~/images/ic_like_outlined.svg";
import IcShare from "~/images/ic_share.svg";
import { typography } from "~/styles/typographies";
import styles from "./ActionButton.module.css";

export interface ActionButtonProps {
  type: "like" | "share";
  status?: "active";
  likesCount?: string;
  onClick: (e: any) => void;
}

export function ActionButton({
  type,
  status,
  likesCount,
  onClick,
}: ActionButtonProps) {
  const { t } = useTranslation("common");
  function getIcon() {
    switch (type) {
      case "like":
        return status === "active" ? IcLikeFilled : IcLike;
      case "share":
        return IcShare;
      default:
        return undefined;
    }
  }

  function getText() {
    switch (type) {
      case "like":
        return likesCount;
      case "share":
        return t("share");
      default:
        return "";
    }
  }

  return (
    <button
      className={cx(
        styles.actionButton,
        typography({ fontSize: "body4", fontWeight: "medium" }),
      )}
      type="button"
      onClick={onClick}
      onMouseUp={e => {
        e.stopPropagation();
      }}
    >
      <img alt={`${type} button`} src={getIcon()} />
      <span>{getText()}</span>
    </button>
  );
}
